import React from 'react';
import { IconProps } from '../IconProps';
const SvgClockInverted = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" fill="none" {...props}>
    <path
      d="M7.5.889A7.12 7.12 0 00.389 8c0 3.92 3.19 7.111 7.11 7.111 3.922 0 7.112-3.19 7.112-7.111C14.61 4.08 11.42.889 7.5.889zm3.437 9.49a.666.666 0 01-.927.17l-2.889-2A.666.666 0 016.834 8V4.222a.667.667 0 011.333 0v3.429l2.602 1.8c.303.21.379.625.169.928z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgClockInverted;
